import React, { useState } from 'react';
import { Col, Row } from 'reactstrap';
import Toggle from 'components/common/Toggle';
import { useTranslation } from 'react-i18next';
import DeleteButton from 'components/buttons/DeleteButton';
import ApiError from 'components/common/ApiError';
import CardWithLoader from 'components/common/CardWithLoader';
import APIResultMessage from 'components/common/APIResultMessage';
import InputList from 'components/common/InputList';
import { useList } from 'hooks/useList';
import { OBJ } from 'constants';
import { bankAccountItems } from './BankAccountDetails';

const BankAccountManager = ({ openSection, setOpenSection, contactId }) => {
    const { t } = useTranslation();
    const [openCategory, setOpenCategory] = useState('');

    const { list, toggleDelete, addLineAndOpen, setAndSaveLineKey, isLoading, error, saveError, success, refetch } = useList(OBJ.BANK_ACCOUNTS, null, null, null, JSON.stringify({contact_id: contactId}));
    if (error) return <ApiError retryFetch={refetch} errorMessage={error.message} />;
    console.log(contactId)
    return (
        <Toggle text={`${t('bank_accounts.title')} (${list?.items.length})`} section="bank_accounts" openSection={openSection} setOpenSection={setOpenSection}>
            <CardWithLoader
                isLoading={isLoading}
                footerButtonClick={() => addLineAndOpen({ id: -1, contact_id: contactId })}
                footerButtonText={t('bank_accounts.new')}
                lines={2}
                height={40}
            >
                <APIResultMessage success={success} error={saveError} />
                {list?.items.map((item) => (
                    <Row key={item.id} className="align-items-center">
                        <Col md="11">
                            <Toggle text={item.account_holder || `#${item.id}`} section={item.id} openSection={openCategory} setOpenSection={setOpenCategory} emptyValue={null}>
                                <InputList fields={bankAccountItems} data={item} onChange={(key, value) => setAndSaveLineKey(item.id, key, value)} />
                            </Toggle>
                        </Col>
                        <Col md="1">
                            <DeleteButton deleteItem={toggleDelete} id={item.id} />
                        </Col>
                    </Row>
                ))}
            </CardWithLoader>
        </Toggle>
    );
};

export default BankAccountManager;
